import React, { ReactNode } from 'react';

interface AlertCardProps {
    tittel: string;
    children: ReactNode;
    showIcon?: boolean;
}

const AlertCard = ({ tittel, children, showIcon = true }: AlertCardProps) => (
    <article className="card card-info alert-card" role="alert" aria-live="assertive">
        <div className="card-content">
            <header className="card-header">
                {showIcon && <i className="ikon-info-36" aria-hidden="true" />}
                <h2>{tittel}</h2>
            </header>
            <div className="card-body">{children}</div>
        </div>
    </article>
);

export default AlertCard;
